import React from 'react';

export default function PortalHeader({ eyebrow, title, description }) {
  return (
    <div className="portal-title">
      <span className="eyebrow">{eyebrow}</span>
      <h1>{title}</h1>
      {description && <p>{description}</p>}
    </div>
  );
}